@if(isDisabled){
<app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        MaxOps Menu Rights
    </div>
    <div class="card-body">
        <div class="row mt-2">
            <div class="col-md-6">
                <ng-select name="user" placeholder="Select User" [items]="Users" bindLabel="UserName"
                    bindValue="UserMasterId" [(ngModel)]="Detail.UserMasterID" (change)="clear()">
                </ng-select>
                <div class="invalid-feedback fs-7">
                    Please select user*
                </div>
            </div>
            <div class="col-auto">
                <button (click)="LoadMaxopsMenuRights('LOAD')" class="btn btn-primary btn-sm">
                    <i class="bi bi-search"></i> Search
                </button>
            </div>
        </div>
        <div class="row mt-4">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;">Check</th>
                        <th>Menu</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let e of Tabledata; let i = index">
                        <td style="width: 5px;">{{i+1}}</td>
                        <td style="text-align: center; width: 5px;">
                            <input class="form-check-input" name="reset{{i}}" id="res{{i}}" type="checkbox"
                                [(ngModel)]="e.isActive" [checked]="e['isActive']" />
                        </td>
                        <td>{{e['PageName']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="LoadMaxopsMenuRights('SAVE')" [disabled]="isDisabled" class="btn btn-primary btn-sm"><i class="bi bi-bookmark"></i> Save</button>
            </div>
        </div>
    </div>
</div>